import * as S from '@/pages/Home/style';
import mainBanner1 from '@/assets/img/banner/banner_main01.jpg';
import mainBanner2 from '@/assets/img/banner/banner_main02.jpg';
import ci2 from '@/assets/img/logo/ci/공동주최2.png';
import ci3 from '@/assets/img/logo/ci/공동주최3.png';
import ci6 from '@/assets/img/logo/ci/후원2.png';
import ci8 from '@/assets/img/logo/ci/추가로고1.png';
import ci9 from '@/assets/img/logo/ci/글로벌조직감각면역연구센터.png';
import ci10 from '@/assets/img/logo/ci/노화융합연구단.jpg';
import ci11 from '@/assets/img/logo/ci/숙명여자대학교 약학연구소 글로컬랩.png';

import conferenceImg from '@/assets/img/conferenceImg.jpeg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { CONF_TITLE, CONF_TITLE_SUB } from '@/constants/menu';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { CardContainer } from '@/components/common/Card/CardContainer/style';
import IntroudceIcon from '@/assets/img/icon/introduceIcon.svg';
import ApplicationIcon from '@/assets/img/icon/applicationIcon.svg';
import ConferenceIcon from '@/assets/img/icon/conferenceIcon.svg';
import InfoplaceIcon from '@/assets/img/icon/infoplaceIcon.svg';
import RegisterIcon from '@/assets/img/icon/registerIcon.svg';
import ArrowRightIcon from '@/assets/img/icon/arrowRightIcon.svg';
import GotoIcon from '@/assets/img/icon/gotoIcon.svg';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CardNotice from '@/components/common/Card/CardNotice/CardNotice';
import useIsMobile from '@/hooks/useIsMobile';
import { useGetInfoApi } from '@/api/notice';
import { convertInfoValue } from '@/utils/convertValue';

const logos = [ci2, ci3, ci6, ci8, ci9, ci10, ci11];

const Home = () => {
	const navigate = useNavigate();
	const isMobile = useIsMobile(1100);
	const [activeTab, setActiveTab] = useState('공지사항');
	const { data: infoData } = useGetInfoApi({
		page: 1,
		type: convertInfoValue(activeTab),
		row: 5,
	});
	const getDynamicField = (g: any, field: string) => {
		const type = convertInfoValue(activeTab);
		return g[`${type}_${field}`] || ''; // 동적으로 필드 처리
	};
	return (
		<S.MainWrapper>
			<div className="container">
				<S.MainBanner>
					<Swiper
						modules={[Navigation, Pagination, Autoplay]}
						slidesPerView={1}
						spaceBetween={0}
						navigation
						pagination={{
							clickable: true,
							el: '.swiper-pagination_custom .swiper-pagination',
						}}
						autoplay={{
							delay: 4000,
							disableOnInteraction: false,
						}}
						loop={true}
						style={{ width: '100%', height: '100%' }}
					>
						<SwiperSlide className="first">
							<img src={mainBanner1} alt="img3" className="first_background" />
							<div className="textBoxWrapper">
								<div className="textBox">
									<h1 className="title">
										THE KOREAN SOCIETY
										<br />
										FOR GERONTOLOGY
									</h1>
									<p className="description">
										한국노화학회는 노화와 노인성질환연구를 통해
										<br style={isMobile ? {} : { display: 'none' }} /> 행복한 노년의 삶을 위한 연구를 수행합니다.
										<br />
										또한 학술활동을 통해 미래의 노화 연구자 육성에 <br style={isMobile ? {} : { display: 'none' }} />
										최선을 다하겠습니다.
									</p>
								</div>
							</div>
						</SwiperSlide>
						<SwiperSlide className="first">
							<img src={mainBanner2} alt="img3" className="first_background" />
							<div className="textBoxWrapper">
								<div className="textBox">
									<h1 className="title">
										THE KOREAN SOCIETY
										<br />
										FOR GERONTOLOGY
									</h1>
									<p className="description">
										한국노화학회는 노화와 노인성질환연구를 통해 행복한 노년의 삶을 위한 연구를 수행합니다.
										<br />
										또한 학술활동을 통해 미래의 노화 연구자 육성에 최선을 다하겠습니다.
									</p>
								</div>
							</div>
						</SwiperSlide>
						<div className="swiper-pagination_custom">
							<div className="swiper-pagination" />
						</div>
					</Swiper>
				</S.MainBanner>
			</div>
			<S.Description>
				<div className="main_description_title">
					<h2 className="description_title">
						한국노화학회, <br style={isMobile ? {} : { display: 'none' }} />
						연구와 교류의 중심
					</h2>
					<p className="description_sub_title">
						{' '}
						건강한 노화를 위한 연구와 학술 교류의 장, 한국노화학회에서 최신 연구를 접하고
						<br style={isMobile ? {} : { display: 'none' }} /> 전문가들과 소통하세요.
					</p>
				</div>
				<S.CardList>
					<CardContainer className={` border-right border-bottom`} onClick={() => navigate('/introduce')}>
						<S.CardWrapper>
							<S.CardTitle>
								학회소개
								<img src={ArrowRightIcon} alt="arrowRight" />
							</S.CardTitle>
							<S.CardSubTitle>
								노화 연구 발전과 학술 교류를 위한 학회의
								<br style={isMobile ? { display: 'none' } : {}} />
								역사와 비전을 소개합니다.
							</S.CardSubTitle>
						</S.CardWrapper>
						<S.ImgBoxWrapper>
							<S.ImgBox>
								<img src={IntroudceIcon} alt="introduce" />
							</S.ImgBox>
						</S.ImgBoxWrapper>
					</CardContainer>
					<CardContainer className={`border-right border-bottom`} onClick={() => navigate('/auth/signup')}>
						<S.CardWrapper>
							<S.CardTitle>
								회원가입
								<img src={ArrowRightIcon} alt="arrowRight" />
							</S.CardTitle>
							<S.CardSubTitle>
								학술대회 참여, 연구 자료 이용, 전문가
								<br style={isMobile ? { display: 'none' } : {}} />
								네트워크 등의 혜택을 제공합니다.
							</S.CardSubTitle>
						</S.CardWrapper>
						<S.ImgBoxWrapper>
							<S.ImgBox>
								<img src={RegisterIcon} alt="introduce" />
							</S.ImgBox>
						</S.ImgBoxWrapper>
					</CardContainer>
					<CardContainer
						className={` ${isMobile ? 'border-right' : ''} border-bottom`}
						onClick={() => navigate('/conference', { state: { menu: '학술대회 안내', depthMenu: '등록안내' } })}
					>
						<S.CardWrapper>
							<S.CardTitle>
								학회등록
								<img src={ArrowRightIcon} alt="arrowRight" />
							</S.CardTitle>
							<S.CardSubTitle>
								학회의 다양한 행사와 프로그램 등록
								<br style={isMobile ? { display: 'none' } : {}} />
								절차를 확인하고, 참여 신청을 진행하세요.
							</S.CardSubTitle>
						</S.CardWrapper>
						<S.ImgBoxWrapper>
							<S.ImgBox>
								<img src={ApplicationIcon} alt="introduce" />
							</S.ImgBox>
						</S.ImgBoxWrapper>
					</CardContainer>
					<CardContainer className={` ${isMobile ? '' : 'border-right'}`} onClick={() => navigate('/conference')}>
						<S.CardWrapper>
							<S.CardTitle>
								학술대회
								<img src={ArrowRightIcon} alt="arrowRight" />
							</S.CardTitle>
							<S.CardSubTitle>
								학술대회를 통해 최신 연구 동향을 <br />
								공유하고 연구자들과 교류하세요.
							</S.CardSubTitle>
						</S.CardWrapper>
						<S.ImgBoxWrapper>
							<S.ImgBox>
								<img src={ConferenceIcon} alt="introduce" />
							</S.ImgBox>
						</S.ImgBoxWrapper>
					</CardContainer>
					<CardContainer className={` ${isMobile ? 'border-right' : ''}`} onClick={() => navigate('/infoplace')}>
						<S.CardWrapper>
							<S.CardTitle>
								정보광장
								<img src={ArrowRightIcon} alt="arrowRight" />
							</S.CardTitle>
							<S.CardSubTitle>
								최신 연구 자료, 학술 논문, 뉴스 및 학회 소식
								<br style={isMobile ? { display: 'none' } : {}} /> 등 다양한 정보를 확인할 수 있습니다.
							</S.CardSubTitle>
						</S.CardWrapper>
						<S.ImgBoxWrapper>
							<S.ImgBox>
								<img src={InfoplaceIcon} alt="introduce" />
							</S.ImgBox>
						</S.ImgBoxWrapper>
					</CardContainer>
					<CardContainer className="dark" onClick={() => window.open('https://www.e-agmr.org/')}>
						<S.CardWrapper>
							<S.CardTitle>
								AGMR
								<img src={ArrowRightIcon} alt="arrowRight" />
							</S.CardTitle>
							<S.CardSubTitle>
								Official Journal of the Korean Geriatrics Society
								<br style={isMobile ? { display: 'none' } : {}} />
								and the Korean Society Gerontology
								<br style={isMobile ? { display: 'none' } : {}} />
								Open Access, Peer-reviewed
							</S.CardSubTitle>
						</S.CardWrapper>
					</CardContainer>
				</S.CardList>
			</S.Description>
			<S.Notice>
				<S.NoticeContent>
					<S.NoticeTabList>
						<S.Wrapper>
							<S.ButtonList>
								<S.TabButton isActive={activeTab === '공지사항'} onClick={() => setActiveTab('공지사항')}>
									공지사항
								</S.TabButton>
								<S.Divider />
								<S.TabButton isActive={activeTab === '소식지'} onClick={() => setActiveTab('소식지')}>
									소식지
								</S.TabButton>
							</S.ButtonList>
							<S.GotoButton type="button" onClick={() => navigate('/infoplace', { state: { menu: activeTab } })}>
								바로가기
								<img src={GotoIcon} />
							</S.GotoButton>
						</S.Wrapper>
						{!isMobile && (
							<S.Wrapper>
								<S.EmptyEl />
							</S.Wrapper>
						)}
					</S.NoticeTabList>

					<S.NoticeContentList>
						<CardNotice>
							<S.NoticeList>
								{infoData &&
									(infoData[convertInfoValue(activeTab)] ?? []).map((g, i) => (
										<S.NoticeListItem key={i} onClick={() => navigate(`/infoplace/detail/${getDynamicField(g, 'pk')}`, { state: { menu: activeTab } })}>
											<div className="title">{getDynamicField(g, 'title')}</div>
											<div className="sub_title">{dayjs(getDynamicField(g, 'enrollment_date')).format('YYYY-MM-DD')}</div>
										</S.NoticeListItem>
									))}
							</S.NoticeList>
							{infoData && (
								<S.NoticeEmptyBox>
									{(infoData[convertInfoValue(activeTab)] ?? [])?.length < 1 && <S.EmptyData>해당 데이터가 없습니다.</S.EmptyData>}
								</S.NoticeEmptyBox>
							)}
						</CardNotice>
						<S.CardImg onClick={() => navigate(`/conference`)} bgImg={conferenceImg}>
							<div className="title_box">
								<div className="title" dangerouslySetInnerHTML={{ __html: CONF_TITLE_SUB }} />
								{/* <div className="sub_title">Toward Healthy and Dignified Aging</div> */}
							</div>
						</S.CardImg>
					</S.NoticeContentList>
				</S.NoticeContent>
			</S.Notice>

			<S.Company>
				<h4 className="title">공동주관 및 후원</h4>
				<Swiper
					modules={[Navigation, Pagination, Autoplay]}
					slidesPerView={'auto'}
					spaceBetween={16}
					navigation
					pagination={{
						clickable: true,
						el: '.swiper-pagination-custom',
					}}
					autoplay={{
						delay: 4000,
						disableOnInteraction: false,
					}}
					loop={true}
					style={{ width: '100%', height: '100%' }}
				>
					{logos.map((logo, index) => (
						<SwiperSlide className="company_item" key={index}>
							<S.CompanyCard>
								<img src={logo} alt="introduce" />
							</S.CompanyCard>
						</SwiperSlide>
					))}
				</Swiper>
			</S.Company>
		</S.MainWrapper>
	);
};

export default Home;
